import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useSelector, useDispatch } from 'react-redux';
import { atualizarSaldo } from '../../../store/modules/parceiro/actions';
import { Container } from 'react-bootstrap';
import api from '../../../services/API';
import sortFunc from '../../../utils/ordernarColunaInt';

const columns = [
  {
    dataField: 'codigo',
    text: 'Código',
  },
  {
    dataField: 'nome',
    text: 'Produto',
  },
  {
    dataField: 'valorPontos',
    text: 'Pontos',
    formatter: (celula, valor) => {
      return Number(valor.valorPontos).toLocaleString('pt-BR');
    },
    sort: true,
    sortFunc: sortFunc,
  },
];

const defaultSorted = [
  {
    dataField: 'valorPontos',
    order: 'desc',
  },
];

export default function ListaPontos() {
  const dispatch = useDispatch()
  const parceiro = useSelector((state) => state.parceiro);

  useEffect(() => {
    buscarProdutos();
    dispatch(atualizarSaldo(parceiro.cpf));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const buscarProdutos = async () => {
    const resultado = await api.get('/api/produtos/pontos');
    if (resultado) {
      setData(resultado.data.produtos);
    }
  };

  const [data, setData] = useState([]);

  return (
    <Container className="mt-5 mb-5">
      <div>
        <h5>PONTOS POR PRODUTO</h5>
        <hr className="hr-loja mt-0" />
      </div>
      <div>
        <BootstrapTable
          className="tabela-fundo-claro"
          keyField="id"
          data={data}
          columns={columns}
          defaultSorted={defaultSorted}
          pagination={paginationFactory({ sizePerPage: 50 })}
          headerClasses="tabela-header-claro"
          bodyClasses="tabela-body-claro"
          bootstrap4
        />
      </div>
    </Container>
  );
}
